import { ScheduleTenureUnit } from "@mpt-fo/common/core/wcl/loan-schedule-simulation.models";
import { Tenure } from "../../wcl-brm-section.models";

export function groupTenureOptions(tenureOptions: Tenure[]){
    if (!tenureOptions?.length) {
      return {
        [ScheduleTenureUnit.WEEKS]: [],
        [ScheduleTenureUnit.MONTHS]: [],
      };
    }

    const weeksOptions = tenureOptions.filter?.(
      (option) => option.tenureUnit === ScheduleTenureUnit.WEEKS,
    );
    const monthsOptions = tenureOptions.filter?.(
      (option) => option.tenureUnit === ScheduleTenureUnit.MONTHS,
    );

    return {
      [ScheduleTenureUnit.WEEKS]: weeksOptions,
      [ScheduleTenureUnit.MONTHS]: monthsOptions,
    };
}

export function getLabeledValuedTenureOptions(options: Tenure[]) {
    return options.map?.((option) => ({
      ...option,
      label: option.tenure,
      value: option.tenure,
    }));
}
